"use strict";

import Vimeo from "@vimeo/player";
//import { LiteVimeoEmbed } from '@slightlyoff/lite-vimeo';
import throttle from "lodash/throttle";

export default class VimeoVideo {
    constructor(el) {
      this.el = el;
      this.options = {
        id: this.el.dataset.id,
        loop: true,
        byline: false,
        title: false,
        portrait: false,
        color: "FDB927",
        defer: true,
      };
      this.player = new Vimeo(el, this.options);
    }
  
    add_tracking() {
      this.player.on("play", () => {
        if (window.dataLayer)  window.dataLayer.push({ event: "video_start" });
      });
    }
  
    pin_height() {
      const compute = () => {
        const r = this.height / this.el.clientHeight;
        this.el.querySelector("iframe").style.width = `${this.width / r}px`;
        this.el.querySelector("iframe").style.height = `${this.el.clientHeight}px`;
      };
      Promise.all([
        this.player.getVideoWidth(),
        this.player.getVideoHeight(),
      ]).then((dimensions) => {
        this.width = dimensions[0];
        this.height = dimensions[1];
        compute();
        window.addEventListener("resize", throttle(compute, 100));
      });
    }
  
    pin_width() {
      const compute = () => {
        const r = this.width / this.el.clientWidth;
        this.el.querySelector("iframe").style.height = `${this.height / r}px`;
        this.el.querySelector("iframe").style.width = `${this.el.clientWidth}px`;
      };
      Promise.all([
        this.player.getVideoWidth(),
        this.player.getVideoHeight(),
      ]).then((dimensions) => {
        this.width = dimensions[0];
        this.height = dimensions[1];
        compute();
        window.addEventListener("resize", throttle(compute, 100));
      });
    }
}